import type { InventoryStockLevelKey } from './stock-level-key.js';

export const INVENTORY_STOCK_LEVEL_LABELS: Record<InventoryStockLevelKey, string> = {
  OUT_OF_STOCK: 'Out of stock',
  BELOW_REORDER: 'Below reorder',
  OVERSTOCKED: 'Over max',
  IN_RANGE: 'In range',
  NO_LEVELS: 'No levels set',
  NEVER_STOCKED: 'Never stocked',
};
